import React from "react";
import { Phone, MapPin } from "lucide-react";
import { PHONE_TEL, MAPS_DIRECTIONS_URL } from "../../lib/businessInfo";

/**
 * Mobile-only sticky conversion bar: Call Now + Directions.
 * Hidden on >= md (desktop already exposes these CTAs in the nav/hero).
 * Both actions are GTM-tracked via the standardized data-gtm attributes.
 */
export default function MobileCTABar() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white/95 backdrop-blur-md shadow-[0_-2px_12px_rgba(15,23,42,0.08)] pb-[env(safe-area-inset-bottom)] md:hidden"
      role="region"
      aria-label="Quick contact actions"
    >
      <div className="mx-auto grid max-w-md grid-cols-2 gap-2.5 px-3 py-2.5">
        <a
          href={PHONE_TEL}
          data-gtm="phone-click"
          className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-lg bg-[var(--color-teal-600)] px-4 font-semibold text-white shadow-sm transition-colors hover:bg-[var(--color-teal-700)] touch-manipulation"
        >
          <Phone size={18} strokeWidth={2.25} className="shrink-0" aria-hidden />
          Call Now
        </a>

        <a
          href={MAPS_DIRECTIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-gtm="directions-click"
          className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-lg border-2 border-[var(--color-primary)] bg-white px-4 font-semibold text-[var(--color-primary)] transition-colors hover:bg-[var(--color-primary)] hover:text-white touch-manipulation"
        >
          <MapPin size={18} strokeWidth={2.25} className="shrink-0" aria-hidden />
          Directions
        </a>
      </div>
    </div>
  );
}
